import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthenticateDomainService } from 'src/app/private/services/authenticate-domain.service';
import { ClientService } from 'src/app/private/services/client.service';
import { EmailHubService } from 'src/app/private/services/email-hub.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { Router } from '@angular/router';
@Component({
  selector: 'app-confirm-email-service',
  templateUrl: './confirm-email-service.component.html',
  styleUrls: ['./confirm-email-service.component.scss']
})
export class ConfirmEmailServiceComponent {
@Input() visible: any = false;
@Output() close = new EventEmitter<void>();
@Output() saved = new EventEmitter<void>();
@Input() moduleType:any;
selectedProvider: 'ses' | 'outlook' | null = null;
isSaving = false;
isConnectLoading = false;
organisationEmails: string[] = [];
loggedInEmail: string | null = null;
outlookError: string | null = null;
isEmailLoading = false;
selectedFromEmail: string | null = null;
communicationPref: any = '';
defaultFromEmail: string | null = null;
emailFallbackMessage: string | null = null;
noClientConfigFound = false;
clientSettingsUrl = 'main/client-settings';

private MODULE_CONFIG_MAP: any = {
  leads: 'lead_communication_email_config',
  campaign: 'marketing_campaign_email_config',
  sequence: 'sequence_email_config'
};
constructor(
  private outlookApi: EmailHubService,
  private localStorage: LocalStorageService,
  private domainService: AuthenticateDomainService,
  private clientService:ClientService,
  private userApi:UsersService,
  private router:Router,
) {}


getCommincationPref() {
  let payload: any = {
              where: {
                user_id: this.localStorage.getUserId()
              },
            };
  this.userApi.getUser(payload).subscribe({
    next: (res: any) => {
      console.log('User details fetched for commincation pref:', res);
      this.communicationPref = res?.commincation_pref || "" ;
    },
    error: (err:any) => {
      console.error('Failed to fetch user details for commincation pref:', err);
    }
  });
}

setcommincationPref(data: any) {
    this.isSaving = true;
  this.communicationPref = data;
  let payload: any = {
              client_id: this.localStorage.getClientId(),
              user_id: this.localStorage.getUserId(),
              commincation_pref: data 
            };
  this.userApi.updateUser(payload).subscribe({
    next: (res: any) => {
       this.isSaving = false;
      console.log('User commincation pref updated successfully:', res);
      this.localStorage.setCommincationPref({
        provider:this.selectedProvider,
        email:this.selectedFromEmail
      });
        this.close.emit()
    },
    error: (err:any) => {
        this.close.emit()
       this.isSaving = false;
      console.error('Failed to update user commincation pref:', err);
    }
  }); 
}

buildPayload() {
  const payload: any = {
    lead_communication_email_config: {
      provider: '',
      email: ''
    },
    marketing_campaign_email_config: {
      provider: '',
      email: ''
    },
    sequence_email_config: {
      provider: '',
      email: ''
    }
  };

  const key = this.MODULE_CONFIG_MAP[this.moduleType];

  if (key) {
    payload[key] = {
      provider: this.selectedProvider,
      email: this.selectedFromEmail
    };
  }

  return payload;
}
selectProvider(provider: 'ses' | 'outlook') {
  this.selectedProvider = provider;

  // Reset state
  this.organisationEmails = [];
  this.selectedFromEmail = null;
  this.loggedInEmail = null;

  if (provider === 'ses') {
    this.loadOrganisationEmails();
  }

  if (provider === 'outlook') {
    this.handleConnectAccount();

  }
}

loadOrganisationEmails() {

  // this.organisationEmails = ['sales@domain.com','support@domain.com'];
 

   let payload: any = {

              where: {
                client_id: this.localStorage.getClientId()
              },
              order: {
                col: "",
                dir: ""
              }
            };

 this.clientService.getAllClientConfig(payload).subscribe({
  next: (res: any) => {
    this.isEmailLoading = false;

    //const emailConfigs = this.getActiveEmailConfig(res);
    const emailConfigs:any = this.getActiveEmailConfig(res);
    // ❌ No email config at all
    if (!emailConfigs || !Array.isArray(emailConfigs) || emailConfigs.length === 0) {
      this.noClientConfigFound = true;
      this.organisationEmails = [];
      this.loggedInEmail = null;
      this.selectedFromEmail = null;
      this.emailFallbackMessage = null;
      return;
    }
    this.noClientConfigFound = false;
    const activeEmailConfig = emailConfigs.find(
      (cfg: any) => cfg?.is_active === true
    );

    if (!activeEmailConfig) {
      this.organisationEmails = [];
      return;
    }

    // ✅ Store default from_email
    this.defaultFromEmail = activeEmailConfig.settings?.from_email || null;

    this.organisationEmails =
      activeEmailConfig.settings?.organisation_email || [];

    // ✅ Try user-specific email
    const userEmail:any = this.organisationEmails.find(
      (e: any) => e.user_id === this.localStorage.getUserId()
    );

    if (userEmail) {
      this.loggedInEmail = userEmail.email;
      this.selectedFromEmail = userEmail.email;
      this.emailFallbackMessage = null;
    } 
    else if (this.defaultFromEmail) {
      // 🔁 Fallback to from_email
      this.loggedInEmail = this.defaultFromEmail;
      this.selectedFromEmail = this.defaultFromEmail;

      this.emailFallbackMessage =
        'No email found for logged-in user. Using default email.';
    } 
    else {
      this.loggedInEmail = null;
      this.selectedFromEmail = null;
      this.emailFallbackMessage =
        'No email configured. Please contact admin.';
    }
  },
  error: (err) => {
    this.isEmailLoading = false;
    console.error(err);
  }
});
}
goToClientSettings() {
  if(this.moduleType   === 'lead') {
    this.router.navigate(['/main/client-settings', 'communication']);
  } 
  else if(this.moduleType   === 'email-campaign') {
    this.router.navigate(['/main/client-settings', 'notification']);
  } 
  else if(this.moduleType   === 'sequence') {
    this.router.navigate(['/main/client-settings', 'communication']);
  }
   else if(this.moduleType   === 'whatsapp-campaign') {
    this.router.navigate(['/main/client-settings', 'whatsapp']);
  }

  setTimeout(() => {
    this.close.emit()
  },1000)
  
}

get isSaveDisabled(): boolean {
  if (this.isSaving) return true;

  if (this.selectedProvider === 'ses' && this.noClientConfigFound) {
    return true;
  }

  return !this.selectedProvider || !this.selectedFromEmail;
}

  getActiveEmailConfig(response: any): any | null {
  if (
    !response ||
    !response.rows ||
    !response.rows.length ||
    !response.rows[0].email_config
  ) {
    return null;
  }

  const emailConfigs = response.rows[0].email_config;
  return emailConfigs;
}
loadLoggedInEmail() {
  this.loggedInEmail = this.localStorage.getEmail();
}
savePreference() {

  if (!this.selectedProvider || !this.selectedFromEmail) return;

  this.setcommincationPref({
      provider: this.selectedProvider,
      email: this.selectedFromEmail
    });



  // this.http.post('/api/email/provider/preference', payload).subscribe({
  //   next: () => {
  //     this.message.add({
  //       severity: 'success',
  //       summary: 'Saved',
  //       detail: 'Email service provider updated successfully'
  //     });
  //     this.isSaving = false;
  //     this.saved.emit();
  //     this.closeModal();
  //   },
  //   error: () => {
  //     this.isSaving = false;
  //     this.message.add({
  //       severity: 'error',
  //       summary: 'Error',
  //       detail: 'Unable to save provider preference'
  //     });
  //   }
  // });
}

closeModal() {
  this.visible = false;
  this.close.emit();
}

handleConnectAccount() {
  this.isConnectLoading = true;

  const payload = {
    client_id: this.localStorage.getClientId(),
    email: this.localStorage.getEmail()
  };

  this.outlookApi.getCodeForOutlookToken(payload).subscribe({
    next: (res: any) => {
      this.isConnectLoading = false;

      const url = res?.message;
      if (!url) {
        this.showError('Failed to start Outlook authentication');
        return;
      }

      this.openOutlookPopup(url);
    },
    error: (err: any) => {
      this.isConnectLoading = false;
      this.showError('Unable to connect Outlook account');
      console.error(err);
    }
  });
}
openOutlookPopup(url: string) {
  const width = 600;
  const height = 600;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;

  const popup = window.open(
    url,
    'OutlookConnect',
    `width=${width},height=${height},top=${top},left=${left}`
  );

  if (!popup) {
      
    this.showError('Popup blocked. Please allow popups and try again.');
    return;
  }

  const timer = setInterval(() => {
    if (popup.closed) {
      clearInterval(timer);
      this.loggedInEmail = this.localStorage.getEmail();
      this.selectedFromEmail = this.localStorage.getEmail();
      window.addEventListener('message', this.handleOutlookMessage, false);
      console.log('Outlook popup closed');
    }
  }, 1000);

  // Listen for message from callback page

}

showError(message: string) {
  this.outlookError = message;
  setTimeout(() => {
    this.outlookError = null;
  }, 5000);
}
showSuccess(message: string) {
  // Implement success message display logic if needed
}
handleOutlookMessage = (event: MessageEvent) => {
  if (!event?.data?.type) return;

  if (event.data.type === 'OUTLOOK_AUTH_SUCCESS') {
    console.log('Outlook authentication successful message received',event);
    const email = event.data.email;

    this.loggedInEmail = this.localStorage.getEmail();
    this.selectedFromEmail = this.localStorage.getEmail();

    this.visible = true; // reopen modal if needed
    this.showSuccess('Outlook account connected successfully');
  }

  if (event.data.type === 'OUTLOOK_AUTH_ERROR') {
    this.showError(event.data.message || 'Outlook authentication failed');
  }

  window.removeEventListener('message', this.handleOutlookMessage);
};
}
